import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthServiceUser } from 'src/app/services/auth/auth.service';

@Directive({
  selector: '[appShowIfPermission]',
  standalone: true
})
export class AuthPermissionDirective {
  @Input('appShowIfPermission') set config(config: { action: string; module?: string }) {
    const { action, module } = config;
    this.updateView(action, module);
  }

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private authService: AuthServiceUser
  ) {}

  private updateView(action: string, module: string): void {
    if (this.authService.hasPermission(action, module)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }

}
